import { createContext } from 'react';

export interface GuestContextType {
	guestId: string | null;
	replyIds: string[];
	updateGuestId: (guestId: string) => void;
}

export default createContext<GuestContextType | null>(null);
